import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import { machineReducer } from "./machineReducer";
import { scopedFindingRuleReducer } from "./scopedFindingRuleReducer";
import { anomalyRuleReducer } from "./anomalyRuleReducer";
import { selectFindingRuleReducer } from "./selectFindingRuleReducer";
import { scopedMenuReducer } from "./scopedMenuReducer";
import { scopeListReducer } from "./scopeListReducer";
import recommendationListReducer from "./recommendationListReducer";
import { scopedAnomalyRuleReducer } from "./scopedAnomalyRuleReducer";
import { selectScopedAnomalyRuleReducer } from "./selectScopedAnomalyRuleReducer";
import { detailsPersistReducer } from "./detailsPersistReducer";
import { breadcrumbReducer } from "./breadcrumbReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const rootReducer = combineReducers({
  machine: machineReducer,
  scopedFindingRule: scopedFindingRuleReducer,
  anomalyRule: anomalyRuleReducer,
  recommendation: recommendationListReducer,
  selectFindingRule: selectFindingRuleReducer,
  selectMenuData: scopedMenuReducer,
  scopeList: scopeListReducer,
  scopedAnomalyRule: scopedAnomalyRuleReducer,
  selectScopedAnomalyRule: selectScopedAnomalyRuleReducer,
  detailsPersist: detailsPersistReducer,
  breadcrumb: breadcrumbReducer,
});
// export default rootReducer
export default persistReducer(persistConfig, rootReducer);
